import { apiSlice } from "./apiSlice";

export const careerApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createCareer: builder.mutation({
      query: (careerData) => ({
        url: "/careers/createCareer",
        method: "POST",
        body: careerData,
      }),
      invalidatesTags: ["Career"],
    }),

    deleteCareer: builder.mutation({
      query: (id) => ({
        url: `/careers/deleteCareer/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Career"],
    }),

    updateCareer: builder.mutation({
      query: ({ careerData, id }) => ({
        url: `/careers/updateCareer/${id}`,
        method: "PATCH",
        body: careerData,
      }),
      invalidatesTags: ["Career"],
    }),

    getAllCareers: builder.query({
      query: ({ page = 1, search } = {}) => {
        const params = new URLSearchParams();
        params.append("page", page);
        if (search) params.append("search", search);

        return {
          url: `/careers/getAllCareers?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: ["Career"],
    }),
    getCareerById: builder.query({
      query: (id) => ({
        url: `/careers/getCareerById/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreateCareerMutation,
  useUpdateCareerMutation,
  useDeleteCareerMutation,
  useGetAllCareersQuery,
  useGetCareerByIdQuery,
} = careerApi;
